import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import { Button, Form } from "react-bootstrap";
import { useParams } from "react-router-dom";
import styles from './productpage.module.css'
import { ButtonStyle } from "../UIElements/Buttons/ButtonStyle";
import authservice from "../Authentication/service/authservice";
import LargeRectangle from "../advertisements/LargeRectangle";
import BillBoard from "../advertisements/BillBoard";
import sty from '../listings/forms/addpost.module.css';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import dateFormator from '../utility/dateFormator';
import invoice_logo from '../../assets/invoice_logo.jpg'
import numWords from 'num-words';
import ReactPaginate from 'react-paginate';

const MyOrder = (props) => {
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const invoiceRef = useRef();
    const [currentPage, setCurrentPage] = useState(0);
    const [pageCount, setPageCount] = useState(1);

    const [activeTab, setActiveTab] = useState("orders");
    const [serviceBookings, setServiceBookings] = useState([]);
    const [servicePageCount, setServicePageCount] = useState(1);
    const [selectedServiceBooking, setSelectedServiceBooking] = useState(null);
    const [servicePage, setServicePage] = useState(0);


    const downloadPDF = () => {
        const doc = new jsPDF();
        const order = selectedOrder;
        const startY = 30;

        // Table Data
        const tableData = order.orderItems.map((item, index) => [
            index + 1,
            item.product.productName,
            item.unitBasePrice,
            item.quantity,
            item.totalBasePrice,
            item.gstPercentage,
            item.cgst,
            item.sgst,
            item.igst,
            item.price,
        ]);

        autoTable(doc, {
            //startY: infoBlockEndY + 4,
            head: [[
                "#", "Item", "Unit Price", "Qty", "Net Price",
                "GST %", "CGST", "SGST", "IGST", "Total Price"
            ]],
            body: tableData,
            styles: { fontSize: 8 },
            headStyles: { fillColor: [231, 243, 230], textColor: 0 },
            alternateRowStyles: { fillColor: [245, 245, 245] },
            margin: { top: 65, left: 14, right: 14, bottom: 60 }, // 👈 key part to add
            didDrawPage: (data) => {

                const pageWidth = doc.internal.pageSize.getWidth();
                const leftMargin = 14;
                const colWidth = 60;
                const colSpacing = 6;
                const col1X = 14;
                const col2X = col1X + colWidth + colSpacing;
                const col3X = col2X + colWidth + colSpacing;
                const startY = 30;

                // Header: Logo and Title
                doc.addImage(invoice_logo, "JPG", 12, 10, 70, 15);
                doc.setFontSize(18);
                doc.setFont('helvetica', 'bold');
                doc.text('INVOICE', 200 - 14, 20, { align: 'right' });

                // Invoice Columns
                doc.setFontSize(10);
                doc.setFont('helvetica', 'normal');

                const col1 = doc.splitTextToSize(
                    `Ordered From: ${order.mart.martName}\nAddress: ${order.mart.businessAddress}\nContact: ${order.mart.contactNumber}\nGSTIN: ${order.mart.gstNumber || '-'}`,
                    colWidth
                );

                const col2 = doc.splitTextToSize(
                    `Ordered By: ${order.fullName}\nAddress: ${order.deliveryAddress}, ${order.city}, ${order.pinCode}, ${order.state}\nMobile: ${order.mobileNumber}`,
                    colWidth
                );

                const col3 = doc.splitTextToSize(
                    `Order No: ${order.orderNumber}\nOrder Date: ${dateFormator.simpleDateTimeFormat(order.orderDate)}\nDelivery Date: ${dateFormator.simpleDateTimeFormat(order.deliveryDate)}`,
                    colWidth
                );

                const maxLines = Math.max(col1.length, col2.length, col3.length);
                for (let i = 0; i < maxLines; i++) {
                    if (col1[i]) doc.text(col1[i], col1X, startY + i * 5);
                    if (col2[i]) doc.text(col2[i], col2X, startY + i * 5);
                    if (col3[i]) doc.text(col3[i], col3X, startY + i * 5);
                }

                const infoBlockEndY = startY + maxLines * 5 + 2;
                doc.line(14, infoBlockEndY, 200, infoBlockEndY);

                // Footer (only needed on last page but harmless if repeated)
                const pageHeight = doc.internal.pageSize.getHeight();
                const footerStartY = pageHeight - 55;
                let footerTextY = footerStartY + 14;
                const lineFooterHeight = 5;

                doc.setDrawColor(0);
                doc.setLineWidth(0.2);
                doc.line(leftMargin, footerStartY, pageWidth - leftMargin, footerStartY);

                doc.setFontSize(10);
                doc.setFont("helvetica", "normal");
                doc.text("Thanks for shopping. Welcome Again!", leftMargin, footerStartY + 8);

                const disclaimerText = [
                    {
                        label: "Disclaimer: ",
                        content: " All item details and applicable taxes are provided by the respective business owners. The responsibility for correctly applying or not applying taxes rests solely with the business owner. aajubaaju.in assumes no liability for any discrepancies or issues arising in this regard."
                    },
                    {
                        label: "Return Policy: ",
                        content: " aajubaaju.in encourages responsible and fair use of the platform by both buyers and sellers. Any disputes related to a transaction must be reported within 2 days of delivery. Resolution of such disputes is strictly between the buyer and the seller. aajubaaju.in will not participate in or be held responsible for dispute resolution."
                    }
                ];

                disclaimerText.forEach(({ label, content }) => {
                    doc.setFont("helvetica", "bold");
                    doc.text(label, leftMargin, footerTextY);

                    doc.setFont("helvetica", "normal");
                    const fullText = `${label} ${content}`;
                    const wrappedContent = doc.splitTextToSize(fullText, pageWidth - leftMargin * 2);
                    const firstLineWithoutLabel = wrappedContent[0].replace(label, "").trim();

                    if (firstLineWithoutLabel) {
                        doc.text(firstLineWithoutLabel, leftMargin + doc.getTextWidth(label + " ") + 0.5, footerTextY);
                    }

                    for (let i = 1; i < wrappedContent.length; i++) {
                        footerTextY += lineFooterHeight;
                        doc.text(wrappedContent[i], leftMargin, footerTextY);
                    }

                    footerTextY += lineFooterHeight;
                });
            }
        });

        const finalY = doc.lastAutoTable.finalY;
        const boxX = 120;
        const boxY = finalY + 10;
        const lineHeight = 6;

        // Reset font spacing and use normal font
        doc.setCharSpace(0); // Fix spacing issue
        doc.setFontSize(10);
        doc.setFont('helvetica', 'normal');

        // Labels
        doc.text("Gross Total", boxX, boxY);
        doc.text("Platform Fee", boxX, boxY + lineHeight);
        doc.text("Payment Gateway Charges (2%)", boxX, boxY + lineHeight * 2);
        doc.setFont('helvetica', 'bold');
        doc.text("NET AMOUNT PAYABLE", boxX, boxY + lineHeight * 3);

        // Values - right aligned
        doc.setFont('arial', 'normal');
        doc.text(`${order.productOrderPayment.grossTotal}`, 200 - 10, boxY, { align: 'right' });
        doc.text(`${order.productOrderPayment.platformFee}`, 200 - 10, boxY + lineHeight, { align: 'right' });
        doc.text(`${order.productOrderPayment.paymentGatway}`, 200 - 10, boxY + lineHeight * 2, { align: 'right' });
        doc.setFont('arial', 'bold');
        doc.text(`${order.productOrderPayment.netTotal}`, 200 - 10, boxY + lineHeight * 3, { align: 'right' });

        // Amount in words
        const amountInWords = convertToRupeesWords(order.productOrderPayment.netTotal);
        doc.setFontSize(10);
        doc.setFont('helvetica', 'normal');
        doc.text(amountInWords, 14, boxY + lineHeight * 5);

        doc.save("invoice.pdf");
    };


    const convertToRupeesWords = (amount) => {
        const [rupees, paise] = amount.toFixed(2).split('.').map(Number);
        let result = `Rupees ${numWords(rupees)}`;
        if (paise > 0) {
            result += ` and ${numWords(paise)} paise`;
        }
        return result + ' only.';
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        fetchOrders(0);
    }, []);


    const fetchOrders = async (page = 0) => {
        const userId = authservice.getCurrentUserid();
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/product/v2-order/user?page=${page}`);
            if (response.status === 200) {
                setOrders(response.data.data);
                setCurrentPage(page);
                setPageCount(response.data.pageCount || 1);
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const fetchServiceBookings = async (page = 0) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/abmgr/mart/booking/v2-order/user?page=${page}`);
            if (response.status === 200) {
                setServiceBookings(response.data.data || []);
                setServicePage(page);
                setServicePageCount(response.data.pageCount || 1);
            }
        } catch (err) {
            setError(err.message);
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);

        if (activeTab === "orders") {
            fetchOrders(0);
        } else {
            fetchServiceBookings(0);
        }
    }, [activeTab]);


    const handlePageClick = (event) => {
        const selectedPage = event.selected;
        fetchOrders(selectedPage); // fetch products for that page
    };

    if (loading) return <p>Loading orders...</p>;
    if (error) return <p>Error: {error}</p>;

    return (
        <div className="admin-view-head">
            <div className="mt-4 g-2 col-md-12">
                <div className="col-md-2 add_button animated_back_button text-right">
                    <ButtonStyle type="button" className="form-control btn btn-block btn_font"
                        handleClick={() => props.history.push("/mart")}>&nbsp; &laquo; &nbsp; Go Back </ButtonStyle>
                </div>
                {!selectedOrder && !selectedServiceBooking ? (
                    <>
                        {/* <h2 className={styles.productName}>Manage Orders</h2> */}

                        <div className="d-flex w-100 text-center mt-5">
                            <div
                                className='flex-fill py-2 fw-bold border'
                                style={{
                                    cursor: 'pointer',
                                    backgroundColor: activeTab === 'orders' ? '#FF9933' : '#f8f9fa',
                                    color: activeTab === 'orders' ? '#fff' : '#000',
                                }}
                                onClick={() => {
                                    setSelectedOrder(null);
                                    setSelectedServiceBooking(null);
                                    setActiveTab("orders");
                                }}
                            >
                                Manage Orders
                            </div>
                            <div
                                className='flex-fill py-2 fw-bold border'
                                style={{
                                    cursor: 'pointer',
                                    backgroundColor: activeTab === 'services' ? '#FF9933' : '#f8f9fa',
                                    color: activeTab === 'services' ? '#fff' : '#000',
                                }}
                                onClick={() => {
                                    setSelectedOrder(null);
                                    setSelectedServiceBooking(null);
                                    setActiveTab("services");
                                }}
                            >
                                Services Booking
                            </div>
                        </div>

                        {activeTab === "orders" && (
                            <>
                                <h2 className={styles.productName}>Manage Orders</h2>

                                <p><strong>Note:  If you have any issues or concerns with your order, submit a Contact Support Form request with subject as "Order Issues" within 48 hours after your order status shows "Order Delivered" <br></br>
                                    Message on 8341370819 for guidance to raise the support request.</strong></p>
                                <div className="table-responsive">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Mart Name</th>
                                                <th>Order Number</th>
                                                <th>Order Date</th>
                                                <th>Total Price</th>
                                                <th>Order Status</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {orders.map((order) => (
                                                <tr key={order.id}>
                                                    <td>{order.mart.martName}</td>
                                                    <td>{order.orderNumber}</td>
                                                    <td>{new Date(order.orderDate).toLocaleString()}</td>
                                                    <td>{order.netTotalPrice}</td>
                                                    <td>{order.orderStatus}</td>
                                                    <td>
                                                        <Button className="secondary" variant="secondary" onClick={() => { setSelectedServiceBooking(null); setSelectedOrder(order) }}>
                                                            List
                                                        </Button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table></div><br></br>
                                {pageCount > 1 && (
                                    <div className="pagination-container text-center">
                                        <ReactPaginate
                                            previousLabel={"← Prev"}
                                            nextLabel={"Next →"}
                                            breakLabel={"..."}
                                            breakClassName={"break-me"}
                                            pageCount={pageCount}
                                            marginPagesDisplayed={2}
                                            pageRangeDisplayed={5}
                                            onPageChange={handlePageClick}
                                            containerClassName={"pagination justify-content-center"}
                                            subContainerClassName={"pages pagination"}
                                            activeClassName={"active"}
                                            forcePage={currentPage}
                                            disabledClassName="pagination_disable_next_prev"
                                        />
                                    </div>
                                )}
                            </>)}

                        {activeTab === "services" && !selectedServiceBooking && (
                            <>
                                <h2 className={styles.productName}>Services Booking</h2>

                                <div className="table-responsive">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Service Name</th>
                                                <th>Booking ID</th>
                                                <th>Booking Date</th>
                                                <th>Appointment Date</th>
                                                <th>Status</th>
                                                <th>Total Amount</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {serviceBookings.map((booking) => (
                                                <tr key={booking.id}>
                                                    <td>{booking.mart.martName}</td>
                                                    <td>{booking.orderNumber}</td>
                                                    <td>{new Date(booking.orderDate).toLocaleString()}</td>
                                                    <td>{new Date(booking.appointmentDate).toLocaleString()}</td>
                                                    <td>{booking.orderStatus}</td>
                                                    <td>₹{booking.netTotalPrice}</td>
                                                    <td>
                                                        <Button className="secondary" variant="secondary" onClick={() => { setSelectedOrder(null); setSelectedServiceBooking(booking) }}>
                                                            List
                                                        </Button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                {servicePageCount > 1 && (
                                    <ReactPaginate
                                        previousLabel={"← Prev"}
                                        nextLabel={"Next →"}
                                        pageCount={servicePageCount}
                                        onPageChange={(e) => fetchServiceBookings(e.selected)}
                                        forcePage={servicePage}
                                        containerClassName={"pagination justify-content-center"}
                                        activeClassName={"active"}
                                    />
                                )}
                            </>
                        )}

                    </>
                ) : (
                    <div>
                        {activeTab === "orders" && selectedOrder && (
                            <>
                                <Button variant="danger" className="popup-close-btn mb-5" onClick={() => setSelectedOrder(null)}>
                                    &times;
                                </Button>

                                {selectedOrder.orderStatus === 'ORDER_DELIVERED' && <Button onClick={downloadPDF} className={styles.download_btn}>Download Invoice</Button>}
                                <div>
                                    <h3><strong>Name: </strong>{selectedOrder.fullName}</h3>
                                    <p><strong>Delivery Address: </strong>{selectedOrder.deliveryAddress}<br></br>
                                        {`${selectedOrder.city}, ${selectedOrder.pinCode}`}<br></br>
                                        {selectedOrder.state}</p>
                                    <h3><strong>Contact Number: </strong>{selectedOrder.mobileNumber}</h3>
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-bordered mt-5">
                                        <thead>
                                            <tr>
                                                <th>Product Name</th>
                                                <th>Category</th>
                                                <th>Size</th>
                                                <th>Quantity</th>
                                                <th>Price</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {selectedOrder.orderItems.map((item) => (
                                                <tr key={item.id}>
                                                    <td>{item.product.productName}</td>
                                                    <td>{item.product.productCategory}</td>
                                                    <td>{item.size}</td>
                                                    <td>{item.quantity}</td>
                                                    <td>₹{item.price}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="popup-buttons">
                                    <Button className="secondary text-center" variant="secondary" onClick={() => setSelectedOrder(null)}>
                                        Close
                                    </Button>
                                </div>
                            </>)}<br></br>

                        {activeTab === "services" && selectedServiceBooking && (
                            <div>
                                <Button
                                    variant="danger"
                                    className="popup-close-btn mb-4"
                                    onClick={() => setSelectedServiceBooking(null)}
                                >
                                    &times;
                                </Button>

                                <h3><strong>Name:</strong> {selectedServiceBooking.mart.martName}</h3>
                                <p><strong>Delivery Address: </strong>{selectedServiceBooking.address}<br></br>
                                    {`${selectedServiceBooking.city}, ${selectedServiceBooking.pinCode}`}<br></br>
                                    {selectedServiceBooking.state}</p>
                                <h3><strong>Contact Number: </strong>{selectedServiceBooking.mobileNumber}</h3>
                                <p><strong>Booking Date:</strong> {new Date(selectedServiceBooking.orderDate).toLocaleString()}</p>

                                <hr />

                                {/* If service items exist */}
                                {selectedServiceBooking.orderItems && (
                                    <div className="table-responsive">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Service</th>
                                                    <th>Appointment Date</th>
                                                    <th>Start Time</th>
                                                    <th>End Time</th>
                                                    <th>Price</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {selectedServiceBooking.orderItems.map((item, idx) => (
                                                    <tr key={idx}>
                                                        <td>{item.serviceOfferingName}</td>
                                                        <td>{new Date(item.appointmentDate).toLocaleString()}</td>
                                                        <td>{item.startTime}</td>
                                                        <td>{item.endTime}</td>
                                                        <td>₹{item.price}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                                <div className="popup-buttons">
                                    <Button className="secondary text-center" variant="secondary" onClick={() => setSelectedServiceBooking(null)}>
                                        Close
                                    </Button>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>
            <div className={`listings row ${sty.large_rect}`}>
                {!props.isAdmin && <LargeRectangle spot={"-1"} />}
            </div>
            <div className={`${sty.billBoard} row`} style={{ backgroundColor: '#e5e5f2', paddingTop: '100px', paddingBottom: '100px' }}>
                {!props.isAdmin && <BillBoard spot={"-1"} />}
            </div>
        </div>
    );
};

export default MyOrder;
